import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { App } from 'vue'
import { createRouterGuards } from './router-guards'
import { RouterTransition } from '@/components/transition'
import { PermissionEnum, RoleEnum } from '@/enums'
import { disciplinaryServiceRouters } from '@/views/DisciplinaryService/routers'
export * from './utils'

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index.vue'),
    redirect: {
      name: 'Home',
    },
    meta: {
      title: '首页',
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: '首页',
          icon: 'shouye',
          hideBreadcrumb: true,
        },
      },
      {
        path: '/Notices',
        name: 'Notices',
        component: RouterTransition,
        meta: {
          title: '通知公告',
          icon: 'tongzhigonggao-d64dokne',
        },
        redirect: {
          name: 'Notice',
        },
        children: [
          {
            path: '/notice/list/:page?',
            name: 'Notice',
            component: () => import('@/views/notice/index.vue'),
            meta: {
              title: '我收到的通知公告',
              auth: {
                permissions: [PermissionEnum.通知公告],
              },
            },
          },
          {
            path: '/NoticeRequiringAReturnReceipt',
            name: 'NoticeRequiringAReturnReceipt',
            component: () => import('@/views/notice/NoticeRequiringAr.vue'),
            meta: {
              title: '需回执的通知',
              auth: {
                permissions: [PermissionEnum.需回执的通知],
                roles: [RoleEnum.admin],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },
      {
        path: '/DisciplinaryService/HomeNonIndustryIssue',
        name: 'HomeNonIndustryIssue',
        component: () => import('@/views/DisciplinaryService/NonIndustryIssue.vue'),
        meta: {
          title: '申诉开具证明',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/HomeNonIndustryIssueView/:id',
        name: 'HomeNonIndustryIssueView',
        component: () => import('@/views/DisciplinaryService/NonIndustryIssueView.vue'),
        meta: {
          title: '申诉开具证明查看',
          hideInMenu: true,
          hideBreadcrumb: true,
          auth: [RoleEnum.member]
        },

      },
      {
        path: '/ServiceAnnouncement',
        name: 'ServiceAnnouncement',
        component: () => import('@/views/publicBenefit/ServiceAnnouncement.vue'),
        meta: {
          title: '本所公益服务公示',
          hideInMenu: true,
        },
      },
      {
        path: '/MyApplication',
        name: 'MyApplication',
        component: () => import('@/views/publicBenefit/MyApplication.vue'),
        meta: {
          title: '我的申请',
          hideInMenu: true,
        },
      },
      {
        path: '/MyCharityData/HomeServiceForm',
        name: 'HomeServiceForm',
        component: () => import('@/views/publicBenefit/ServiceForm.vue'),
        meta: {
          title: '申报公益服务',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/MyCharityData/HomeProofServiceForm',
        name: 'HomeProofServiceForm',
        component: () => import('@/views/publicBenefit/ProofServiceForm.vue'),
        meta: {
          title: '申请开具证明',
          hideInMenu: true,
        },
      },
      {
        path: '/MyCharityData/HomeServiceFormBs',
        name: 'HomeServiceFormBs',
        component: () => import('@/views/publicBenefitBs/ServiceFormBs.vue'),
        meta: {
          title: '申报公益服务',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/HomeSafeguardRightsView/:id',
        name: 'HomeSafeguardRightsView',
        component: () => import('@/views/DisciplinaryService/SafeguardRightsView.vue'),
        meta: {
          title: '律师维权查看',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/DisciplinaryService/HomeDocumentSubmissionView/:id',
        name: 'HomeDocumentSubmissionView',
        component: () => import('@/views/DisciplinaryService/DocumentSubmissionView.vue'),
        meta: {
          title: '惩戒人员检查信息',
          hideInMenu: true,
          hideBreadcrumb: true,
        },
      },
      {
        path: '/MyCharityData/HomeProofServiceFormBs',
        name: 'HomeProofServiceFormBs',
        component: () => import('@/views/publicBenefitBs/ProofServiceFormBs.vue'),
        meta: {
          title: '申请开具证明',
          hideInMenu: true,
        },
      },
      {
        path: '/MyCharityDataBs',
        name: 'MyCharityDataBs',
        component: RouterTransition,
        meta: {
          title: '个人公益服务',
          icon: 'daohanglan-gerengongyifuwu',
        },
        redirect: {
          name: 'MyProBonoServiceBs',
        },
        children: [
          {
            path: '/MyCharityDataBs/MyProBonoServiceBs',
            name: 'MyProBonoServiceBs',
            component: () => import('@/views/publicBenefitBs/MyProBonoServiceBs.vue'),
            meta: {
              title: '个人公益服务管理',
              auth: {
                permissions: [PermissionEnum.个人公益服务管理],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          {
            path: '/MyCharityDataBs/ServiceFormBs',
            name: 'ServiceFormBs',
            component: () => import('@/views/publicBenefitBs/ServiceFormBs.vue'),
            meta: {
              title: '申报公益服务',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityDataBs/ServiceFormEdteBs/:id',
            name: 'ServiceFormEdteBs',
            component: () => import('@/views/publicBenefitBs/ServiceFormEdteBs.vue'),
            meta: {
              title: '添加表彰及投诉信息',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityDataBs/ProofServiceFormBs',
            name: 'ProofServiceFormBs',
            component: () => import('@/views/publicBenefitBs/ProofServiceFormBs.vue'),
            meta: {
              title: '申请开具证明',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityDataBs/ServiceFormViewBs/:id',
            name: 'ServiceFormViewBs',
            component: () => import('@/views/publicBenefitBs/ProofServiceFormBs.vue'),
            meta: {
              title: '申报公益服务-查看',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityDataBs/ProofOfServiceBs',
            name: 'ProofOfServiceBs',
            component: () => import('@/views/publicBenefitBs/ProofOfServiceBs.vue'),
            meta: {
              title: '个人公益服务证明申请',
              auth: {
                permissions: [PermissionEnum.个人公益服务证明申请],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },
      {
        path: '/MyCharityData',
        name: 'MyCharityData',
        component: RouterTransition,
        meta: {
          title: '本所公益服务',
          icon: 'daohanglan-bensuogongyifuwu',
        },
        redirect: {
          name: 'MyProBonoService',
        },
        children: [
          {
            path: '/MyCharityData/MyProBonoService',
            name: 'MyProBonoService',
            component: () => import('@/views/publicBenefit/MyProBonoService.vue'),
            meta: {
              title: '本所公益服务管理',
              auth: {
                permissions: [PermissionEnum.本所公益服务管理],
                roles: [RoleEnum.admin],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          {
            path: '/MyCharityData/ServiceForm',
            name: 'ServiceForm',
            component: () => import('@/views/publicBenefit/ServiceForm.vue'),
            meta: {
              title: '申报公益服务',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityData/ServiceFormEdte/:id',
            name: 'ServiceFormEdte',
            component: () => import('@/views/publicBenefit/ServiceFormEdte.vue'),
            meta: {
              title: '添加袤彰及投诉信息',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityData/ProofServiceForm',
            name: 'ProofServiceForm',
            component: () => import('@/views/publicBenefit/ProofServiceForm.vue'),
            meta: {
              title: '申请开具证明',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityData/ServiceFormView/:id',
            name: 'ServiceFormView',
            component: () => import('@/views/publicBenefit/ProofServiceForm.vue'),
            meta: {
              title: '申报公益服务-查看',
              hideInMenu: true,
            },
          },
          {
            path: '/MyCharityData/ProofOfService',
            name: 'ProofOfService',
            component: () => import('@/views/publicBenefit/ProofOfService.vue'),
            meta: {
              title: '本所公益服务证明申请',
              auth: {
                permissions: [PermissionEnum.本所公益服务证明申请],
                roles: [RoleEnum.admin],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },
      ...disciplinaryServiceRouters,

      {
        path: '/province-association/:page?',
        component: () => import('@/views/province/index.vue'),
        name: 'ProvinceAssociation',
        meta: {
          title: '数据报送',
          icon: 'shuju',
          auth: {
            permissions: [PermissionEnum['数据报送']],
          },
        },
      },
      {
        path: '/PublicWelfareManagement',
        name: 'PublicWelfareManagement',
        component: RouterTransition,
        meta: {
          title: '公益管理',
          icon: 'daohanglan-gongyiguanli',
        },
        redirect: {
          name: 'PublicServiceDeclaration',
        },
        children: [
          // 律师
          {
            path: '/PublicWelfareManagement/PublicServiceDeclarationBs',
            name: 'PublicServiceDeclarationBs',
            component: () => import('@/views/publicBenefitBs/ServiceDeclaration.vue'),
            meta: {
              title: '本所律师公益服务申报',
              auth: {
                permissions: [PermissionEnum.本所律师公益服务申报],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          {
            path: '/PublicWelfareManagement/MembershipFeeWaiver',
            name: 'MembershipFeeWaiver',
            component: () => import('@/views/publicBenefitBs/MembershipFeeWaiver.vue'),
            meta: {
              title: '本所律师会费减免申报',
              auth: {
                permissions: [PermissionEnum.本所律师公益服务申报],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          {
            path: '/PublicWelfareManagement/MembershipFeeWaiverApprove/:id',
            name: 'MembershipFeeWaiverApprove',
            component: () => import('@/views/publicBenefitBs/MembershipFeeWaiverApprove.vue'),
            meta: {
              title: '审批',
              hideInMenu: true,
            },
          },
          {
            path: '/PublicWelfareManagement/ExamineAndApproveBs/:id',
            name: 'ExamineAndApproveBs',
            component: () => import('@/views/publicBenefitBs/ExamineAndApprove.vue'),
            meta: {
              title: '审批',
              hideInMenu: true,
            },
          },
          // 律所
          {
            path: '/PublicWelfareManagement/PublicServiceDeclaration',
            name: 'PublicServiceDeclaration',
            component: () => import('@/views/publicBenefit/ServiceDeclaration.vue'),
            meta: {
              title: '本所公益服务申报',
              auth: {
                permissions: [PermissionEnum.本所公益服务申报],
                roles: [RoleEnum.admin],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          {
            path: '/PublicWelfareManagement/ExamineAndApprove/:id',
            name: 'ExamineAndApprove',
            component: () => import('@/views/publicBenefit/ExamineAndApprove.vue'),
            meta: {
              title: '审批',
              hideInMenu: true,
            },
          },

        ],
      },
      {
        path: '/my-activities',
        name: 'MyActivities',
        component: RouterTransition,
        meta: {
          title: '我的活动',
          icon: 'wodehuodong',
        },
        children: [
          {
            path: '/my-activities/index',
            name: 'MyActivitiesLsit',
            component: () => import('@/views/my-activities/index.vue'),
            meta: {
              title: '活动管理',
              auth: {
                permissions: [PermissionEnum.我的活动],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },
      // {
      //   path: '/my-activities',
      //   name: 'MyActivities',
      //   component: () => import('@/views/my-activities/index.vue'),
      //   meta: {
      //     title: '我的活动',
      //     icon: 'wodehuodong',
      //   },
      //   auth: {
      //     permissions: [PermissionEnum.我的活动],
      //     roles: [RoleEnum.member],
      //     options: {
      //       priority: 'all',
      //     }
      //   },
      // },
      {
        path: '/changefirm',
        name: 'changefirm',
        component: RouterTransition,
        meta: {
          title: '律师变更执业机构审核',
          icon: 'hezuojigou',
        },
        children: [
          {
            path: '/changefirm/index',
            name: 'changefirmlsit',
            component: () => import('@/views/app-firm/index.vue'),
            meta: {
              title: '审核管理',
              auth: {
                permissions: [PermissionEnum.律师变更执业机构审核],
                roles: [RoleEnum.member, RoleEnum.admin],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },

      {
        path: '/video',
        name: 'video',
        component: RouterTransition,
        meta: {
          title: '学习课堂',
          icon: 'daohanglan-gongyiguanli',
        },
        redirect: {
          name: 'PublicServiceDeclaration',
        },
        children: [
          {
            path: '/video/zs',
            name: 'zs',
            component: () => import('@/views/video/jxjyVideoList.vue'),
            meta: {
              title: '继续教育(智拾资源)',
              auth: {
                permissions: [PermissionEnum.学习课堂],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
          // 律师
          // {
          //   path: '/video/jxjy',
          //   name: 'jxjy',
          //   component: () => import('@/views/video/jxjyVideoList.vue'),
          //   meta: {
          //     title: '继续教育',
          //     auth: {
          //       permissions: [PermissionEnum.学习课堂],
          //       roles: [RoleEnum.member],
          //       options: {
          //         priority: 'all',
          //       }
          //     },
          //   },
          // },
          {
            path: '/video/Points',
            name: 'Points',
            component: () => import('@/views/video/Points.vue'),
            meta: {
              title: '我的学时积分',
              auth: {
                permissions: [PermissionEnum.学习课堂],
                roles: [RoleEnum.member],
                options: {
                  priority: 'all',
                }
              },
            },
          },
        ],
      },
      // {
      //   path: '/case',
      //   name: 'Case',
      //   component: RouterTransition,
      //   meta: {
      //     title: '案件管理',
      //     icon: 'icon-anjianguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'CaseIndex',
      //   },
      //   children: [
      //     {
      //       path: '/case/index/:type?',
      //       name: 'CaseIndex',
      //       component: () => import('@/views/case/index.vue'),
      //       meta: {
      //         title: '案件管理',
      //         auth: {
      //           permissions: [PermissionEnum.案件管理],
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/customer',
      //   name: 'Customer',
      //   component: RouterTransition,
      //   meta: {
      //     title: '客户管理',
      //     icon: 'icon-kehuguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'CustomerIndex',
      //   },
      //   children: [
      //     {
      //       path: '/customer/index',
      //       name: 'CustomerIndex',
      //       component: () => import('@/views/customer/index.vue'),
      //       meta: {
      //         title: '客户管理',
      //         // auth: {
      //         //   permissions: [PermissionEnum['客户管理.查看']],
      //         // },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/vertical',
      //   name: 'Vertical',
      //   component: RouterTransition,
      //   meta: {
      //     title: '利冲检索',
      //     icon: 'icon-lichongjiansuo-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'VerticalIndex',
      //   },
      //   children: [
      //     {
      //       path: '/vertical/index/:type?',
      //       name: 'VerticalIndex',
      //       component: () => import('@/views/vertical/index.vue'),
      //       meta: {
      //         title: '利冲检索',
      //         // auth: {
      //         //   permissions: [PermissionEnum.利冲检索],
      //         // },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/contract',
      //   name: 'Contract',
      //   component: RouterTransition,
      //   meta: {
      //     title: '合同管理',
      //     icon: 'icon-hetongguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'ContractIndex',
      //   },
      //   children: [
      //     {
      //       path: '/contract/index',
      //       name: 'ContractIndex',
      //       component: () => import('@/views/contract/index.vue'),
      //       meta: {
      //         title: '合同管理',
      //         auth: {
      //           permissions: [PermissionEnum.合同管理],
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/seal',
      //   name: 'Seal',
      //   component: RouterTransition,
      //   meta: {
      //     title: '用章管理',
      //     icon: 'icon-yongzhangguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'SealIndex',
      //   },
      //   children: [
      //     {
      //       path: '/seal/index',
      //       name: 'SealIndex',
      //       component: () => import('@/views/seal/index.vue'),
      //       meta: {
      //         title: '用章管理',
      //         auth: {
      //           permissions: [PermissionEnum.用章管理],
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/finance',
      //   name: 'Finance',
      //   component: RouterTransition,
      //   meta: {
      //     title: '财务管理',
      //     icon: 'icon-caiwuguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'FinanceIndex',
      //   },
      //   children: [
      //     {
      //       path: '/finance/index',
      //       name: 'FinanceIndex',
      //       component: () => import('@/views/finance/index.vue'),
      //       meta: {
      //         title: '财务管理',
      //         auth: {
      //           permissions: [PermissionEnum.财务管理],
      //         },
      //       },
      //     },
      //   ],
      // },
      // {
      //   path: '/approve',
      //   name: 'Approve',
      //   component: RouterTransition,
      //   meta: {
      //     title: '审批管理',
      //     icon: 'icon-shenpiguanli-weixuanzhong',
      //   },
      //   redirect: {
      //     name: 'ApproveIndex',
      //   },
      //   children: [
      //     {
      //       path: '/approve/index',
      //       name: 'ApproveIndex',
      //       component: () => import('@/views/approve/index.vue'),
      //       meta: {
      //         title: '审批管理',
      //         auth: {
      //           permissions: [PermissionEnum.审批管理],
      //         },
      //       },
      //     },
      //   ],
      // },

      // {
      //   path: `/business-card`,
      //   name: 'BusinessCard',
      //   component: () => import('@/views/business-card/index.vue'),
      //   meta: {
      //     title: '个人名片',
      //     icon: 'icon-gerenmingpian-weixuanzhong',
      //     auth: {
      //       permissions: [PermissionEnum.个人名片],
      //     },
      //   },
      // },
      // {
      //   path: '/phone',
      //   name: 'Phone',
      //   component: () => import('@/views/phone/index.vue'),
      //   meta: {
      //     title: '行业通讯录',
      //     icon: 'icon-hangyetongxunlu-weixuanzhong',
      //     auth: {
      //       permissions: [PermissionEnum['行业通讯录']],
      //     },
      //   },
      // },

      {
        path: '/system',
        name: 'System',
        component: RouterTransition,
        redirect: {
          name: 'Lawyer',
        },
        meta: {
          title: '基础设置',
          icon: 'shezhi-d64dol06',
          auth: [RoleEnum.admin],
        },
        children: [
          {
            path: '/lawyer',
            name: 'Lawyer',
            component: () => import('@/views/system/lawyer.vue'),
            meta: {
              title: '用户设置',
              roles: [RoleEnum.admin],
              auth: {
                permissions: [PermissionEnum.用户设置],
              },
            },
          },
          // {
          //   path: '/approve-Config',
          //   name: 'ApproveConfig',
          //   component: () => import('@/views/system/approveConfig.vue'),
          //   meta: {
          //     title: '审批设置',
          //     roles: [RoleEnum.admin],
          //     auth: {
          //       permissions: [PermissionEnum.审批设置],
          //     },
          //   },
          // },
        ],
      },
      {
        path: '/exception/:code',
        name: 'Exception',
        meta: {
          title: '403 ',
          hideBreadcrumb: true,
          hideInMenu: true,
        },
        component: () => import('@/views/exception/index.vue'),
      },
      {
        path: '/:path(.*)*',
        meta: {
          title: '404 ',
          hideBreadcrumb: true,
          hideInMenu: true,
        },
        redirect: {
          name: 'Exception',
          params: { code: 404 },
        },
      },
    ],
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
  },
  {
    path: '/PhoneSafeguardRightsForm',
    name: 'PhoneSafeguardRightsForm',
    component: () => import('@/views/DisciplinaryService/PhoneSafeguardRightsForm.vue'),
  },
  // {
  //   path: '/province-association',
  //   name: 'ProvinceAssociation',
  //   meta: {
  //     title: '访问律协数据平台',
  //     icon: 'icon-fangwenhunan-weixuanzhong',
  //   },
  //   component: ThirdPartyRouterView,
  //   redirect: {
  //     name: 'ProvinceAssociationDataCenter',
  //   },
  //   children: [
  //     {
  //       path: '/province-association/:page?',
  //       component: () => import('@/views/province/index.vue'),
  //       name: 'ProvinceAssociationDataCenter',
  //       meta: {
  //         title: '数据报送中心',
  //         // auth: {
  //         //   permissions: [PermissionEnum['访问律协数据平台.数据报送中心']],
  //         // },
  //       },
  //     },
  //     {
  //       path: 'contribution',
  //       name: 'Contribution',
  //       component: () => import('@/views/province/Contribution.vue'),
  //       meta: {
  //         title: '新闻投稿',
  //         auth: {
  //           // permissions: [PermissionEnum['访问律协数据平台.新闻投稿']],
  //         },
  //       },
  //     },
  //     {
  //       path: 'questionnaire',
  //       name: 'Questionnaire',
  //       component: () => import('@/views/province/Questionnaire.vue'),
  //       meta: {
  //         title: '问卷调查',
  //         auth: {
  //           // permissions: [PermissionEnum['访问律协数据平台.问卷调查']],
  //         },
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/delegate',
  //   meta: {
  //     title: '异地查档协助中心',
  //     icon: 'icon-gerenmingpian-weixuanzhong1',
  //     auth: {
  //       permissions: [PermissionEnum.委托广场],
  //     },
  //     hideInMenu: true,
  //   },
  //   component: ThirdPartyRouterView,
  //   name: 'Delegate',
  //   children: [
  //     {
  //       path: '',
  //       name: 'DelegateSquare',
  //       meta: { title: '委托广场' },
  //       component: () => import('@/views/delegate/index.vue'),
  //       children: [],
  //     },
  //     {
  //       path: 'published',
  //       name: 'PublishedDelegate',
  //       meta: { title: '我发布的委托' },
  //       component: () => import('@/views/delegate/Published.vue'),
  //       children: [],
  //     },
  //     {
  //       path: 'received',
  //       name: 'AppliedDelegate',
  //       meta: { title: '我帮助的委托' },
  //       component: () => import('@/views/delegate/Applied.vue'),
  //       children: [],
  //     },
  //     {
  //       path: 'my-info',
  //       name: 'DelegateMyInfo',
  //       meta: { title: '我的信息', hidden: true },
  //       component: () => import('@/views/delegate/MyInfo.vue'),
  //       children: [],
  //     },
  //   ],
  // },
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})
export function setupRouter(app: App) {
  app.use(router)
  // 创建路由守卫
  createRouterGuards(router)
}
export default router
